import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {PacService} from '../../shared/services/pac.service';
import {PaymentCategory} from '../../models/additional-pac-data.model';

@Component({
  selector: 'app-payment-fail',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './payment-cancel.component.html',
  styleUrl: './payment-cancel.component.scss'
})
export class PaymentCancelComponent {

  constructor(private readonly router: Router, private readonly pacService: PacService) {
  }

  onRetryPayment(): void {
    const pacNumber = "";
    this.pacService.fetchAdditionalInfo(pacNumber, true).subscribe({
      next: (data) => {
        const category = data.paymentCategory;
        if (category === PaymentCategory.COURT_PAYMENT) {
          this.router.navigate(['/court-payment'], {
            state: { pacDetails: data }
          });
        } else if (category === PaymentCategory.COURT_DEPOSIT) {
          this.router.navigate(['/court-deposit-details'], {
            state: { depositInfo: data }
          });
        }
      },
      error: (err) => {
        this.router.navigate([''])
      }
    });
  }
}
